import React from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  DialogContentText,
} from '@mui/material';

type TShowReleaseNoteProps = {
  open: boolean;
  onClose: () => void;
};

const PastPapersReleaseNote: React.FC<TShowReleaseNoteProps> = ({
  open,
  onClose,
}) => {
  return (
    <Dialog
      PaperProps={{
        sx: { borderRadius: '15px', maxWidth: '380px' },
      }}
      open={open}
      onClose={onClose}
    >
      <DialogContent sx={{ textAlign: 'center', position: 'relative' }}>
        <img
          src={`${process.env.PUBLIC_URL}/images/pastPaperPage/releaseNote/header3.png`}
          alt="header"
          style={{ width: '100%', height: '20%' }}
        />

        <DialogContent sx={{ fontWeight: 'bold', fontSize: '14px' }}>
          New Update: Theory Questions Now Available! 📚
        </DialogContent>
        <Typography sx={{ fontSize: '13px' }}>
          We have added Theory Questions in the practice section, providing
          quick feedback on your answers to help you learn and improve
          instantly!
        </Typography>
        <DialogContentText sx={{ fontWeight: 'bold', fontSize: '11px', mt: 2 }}>
          Choose your curriculum ➞ Select Subject ➞ Access Theory Question
        </DialogContentText>
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#1E293B',
            color: 'white',
            mt: 3,
            pl: 3,
            pr: 3,
            '&:hover': {
              backgroundColor: '#787878',
            },
          }}
          onClick={onClose}
        >
          Got it
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default PastPapersReleaseNote;
